export const initialState = {
    directoryList: [],
};

const state = { ...initialState };

export default state;